import { formatText } from "@shared/ui/format";

export interface StringPair {
	name: string;
	value: string;
}

export class JsonDataBuilder {
	private readonly itemsText: StringPair[] = [];
	private itemsJson: Record<string, string | number | boolean> = {};

	public constructor(json: string | Record<string, any> = {}) {
		if (typeof json === "string") {
			this.itemsJson = JSON.parse(json);
		} else {
			this.itemsJson = json;
		}
	}

	public addJsonItem(name: string, value: string | number | boolean): JsonDataBuilder {
		if (value === undefined || value === "undefined" || value === "") {
			return this;
		}

		this.itemsJson[name] = value;

		return this;
	}

	public addTextItem(nameText: string, value: string | number | boolean, format?: string): JsonDataBuilder {
		if (value === undefined || value === "undefined" || value === "") {
			return this;
		}

		this.itemsText.push({
			name: nameText,
			value: formatText(value, format),
		});

		return this;
	}

	public addItem(nameText: string, name: string, value: string | number | boolean, format?: string): JsonDataBuilder {
		if (value === undefined || value === "undefined" || value === "") {
			return this;
		}

		let formatValue = value;

		if (format === "ft") {
			formatValue = Math.round(Number(value));
		}

		return this.addJsonItem(name, formatValue).addTextItem(nameText, formatValue, format);
	}

	public getJson(): string {
		return JSON.stringify(this.itemsJson);
	}

	public getObject(): Record<string, any> {
		if (Object.keys(this.itemsJson).length === 0) {
			return undefined;
		}

		return this.itemsJson;
	}

	public getDataArray(): StringPair[] {
		return this.itemsText;
	}
}
